<template>
  <v-container>
    <v-row no-gutters>
      <v-col
        cols="12"
        class="text-center footer"
        align="center"
      >
        © VueJS / Vuetify CV - VINCENT CAUDRON / 
        <v-icon
          size="10"
          class="mr-2"
        >
          fas fa-globe-europe
        </v-icon>
        <v-btn
          x-small
          text
          to="/"
        >
          FR
        </v-btn>
        <v-btn
          x-small
          text
          to="/en"
        >
          EN
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name:"Footer",
  data: () => ({}),
  mounted (){
    const params = window.location.pathname.split('/')[1].toLowerCase();
    if(params === 'fr' || params === 'en'){
      this.$i18n.locale = params;
    }
  }
}
</script>

<style scoped>
.footer{
  font-size: 10px;
  letter-spacing: 3px;
}
</style>